module.exports = __webpack_public_path__ + "img/LogoEvento.7a4cf8af.png";